module.exports = __webpack_public_path__ + "static/media/region-mobile.72a9fe6e.svg";